var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('VuePhoneNumberInput',{attrs:{"translations":{
			countrySelectorLabel: 'Code pays',
			countrySelectorError: 'Choisir un pays',
			phoneNumberLabel: 'Numéro de téléphone',
			example: 'Exemple :',
		},"no-use-browser-locale":"","preferred-countries":['FR', 'RE', 'BE']},on:{"update":_vm.onNumberTyping},model:{value:(_vm.localPhoneNumber),callback:function ($$v) {_vm.localPhoneNumber=$$v},expression:"localPhoneNumber"}}),_c('input',{attrs:{"type":"hidden","name":_vm.inputName},domProps:{"value":_vm.outputPhoneNumber}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }